export default "__VITE_ASSET__CFEVmfgm__"